import { api } from 'services/api/baseBackendAPI';

export const fundApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFundDetail: build.query({
      query: (fund_id) => ({
        url: `funds/fund-details/${fund_id}`,
        method: 'GET',
      }),
      providesTags: (result, error, fund_id) => [
        { type: 'Fund Detail', id: fund_id },
        'Fund Detail',
      ],
    }),
  }),
  overrideExisting: true,
});

export const { useGetFundDetailQuery } = fundApi;
